import { createGroupsAppController } from '../controllers/appController';

import {
  IWidgetControllerConfig,
  IViewerScript,
  ICreateControllers,
} from '@wix/native-components-infra/dist/src/types/types';

export const createControllers: ICreateControllers = ([
  appControllerConfig,
]: IWidgetControllerConfig[]) => {
  let experiments = {};
  try {
    if (window.__EXPERIMENTS__) {
      experiments = JSON.parse(window.__EXPERIMENTS__);
    }
  } catch (e) {
    console.log('Error getting experiments');
  }
  return [createGroupsAppController(appControllerConfig, experiments)];
};

const viewerScript: IViewerScript = {
  createControllers,
};

export default viewerScript;
